var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.26595C14 8.81823 13.5523 9.26595 13 9.26595H9.40559C8.85331 9.26595 8.40559 9.71366 8.40559 10.2659V13.8604C8.40559 14.4126 7.95788 14.8604 7.40559 14.8604H6.59441C6.04212 14.8604 5.59441 14.4126 5.59441 13.8604V10.2659C5.59441 9.71366 5.14669 9.26595 4.59441 9.26595H1C0.447715 9.26595 0 8.81823 0 8.26595V7.45476C0 6.90247 0.447715 6.45476 1 6.45476H4.59441C5.14669 6.45476 5.59441 6.00704 5.59441 5.45476V1.86035C5.59441 1.30807 6.04212 0.860352 6.59441 0.860352H7.40559C7.95788 0.860352 8.40559 1.30807 8.40559 1.86035V5.45476C8.40559 6.00704 8.85331 6.45476 9.40559 6.45476H13C13.5523 6.45476 14 6.90247 14 7.45476V8.26595Z",
    fill: "#FF5F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.dd5236fd378cbdbb13437c249ec2cd5f.svg";
export { ForwardRef as ReactComponent };